import {
  CLOUD_INTEGRATION_PROVIDERS,
  type CloudIntegrationProvider,
} from '../services/athleteSettingsApi';

export interface CloudOAuthResult {
  provider: CloudIntegrationProvider;
  success: boolean;
  message?: string;
}

export function isCloudIntegrationProvider(value: unknown): value is CloudIntegrationProvider {
  return typeof value === 'string'
    && (CLOUD_INTEGRATION_PROVIDERS as readonly string[]).includes(value);
}

/** Rejects forged or stale postMessage callbacks before they reach UI state. */
export function parseCloudOAuthMessage(
  origin: string,
  data: unknown,
  expectedOrigins: Partial<Record<CloudIntegrationProvider, string>>,
): CloudOAuthResult | null {
  if (typeof data !== 'object' || data === null) return null;

  const candidate = data as Record<string, unknown>;
  const legacyWahoo = candidate.type === 'vo2-wahoo-oauth';
  if (candidate.type !== 'vo2-integration-oauth' && !legacyWahoo) return null;

  const provider = legacyWahoo ? 'wahoo' : candidate.provider;
  if (!isCloudIntegrationProvider(provider) || expectedOrigins[provider] !== origin) return null;
  if (typeof candidate.success !== 'boolean') return null;

  const message = typeof candidate.message === 'string'
    ? candidate.message
    : typeof candidate.error === 'string' ? candidate.error : undefined;

  return { provider, success: candidate.success, message };
}
